module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.b52fac2.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/roboto-fontface/fonts/roboto/Roboto-Bold.woff2
// module id = W+S6
// module chunks = 3